// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607230653/js/" + chunkId + "." + {"44":"e25f4410","225":"c5c9d1c9","481":"50d8745c","486":"f3af351f","770":"30d5f057"}[chunkId] + ".0.4888571530797703.chunk.js";
};